import moo from './moo.jpg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Hi, my name is Ginny</h1>
        <img src={moo} className="App-logo" alt="logo" />
   
  
      </header>
    </div>
  );
}

export default App;
